export default __webpack_public_path__ + "static/70-80830bcfc94c66f3ac1f736f2256afe0.gif";